import React, { useEffect, useMemo, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import classnames from "classnames";

import { BetCalculationsEnum, getBetCalculations } from "../../../calculation";
import { BetTypeViewEnum } from "src/constants/enums/betType";
import { ISelection } from "src/constants/interfaces/bet";
import OddConverter from "@common/helpers/oddConverter";
import upperDataStore from "src/stores/upperData";
import { useConfig } from "src/hooks/config";
import mainStore from "src/stores/main";
import { getEffectiveSelectionsCount } from "src/common/helpers/betBuilder";

import "./style.scss";
import { useOutSideClick } from "src/hooks/outSideClick";
import { useTranslation } from "src/hooks/translation";

export interface IProps {
	children: JSX.Element;
	selections: ISelection[];
}

const StickyWrapper = ({ children, selections }: IProps) => {
	const config = useConfig();
	const t = useTranslation();
	const { betType } = useRecoilValue(mainStore);
	const { oddsFormat, partnerConfig, verificationResponse, currencyConfig } = useRecoilValue(upperDataStore);
	const [openBetslip, setOpenBetslip] = useState(false);
	const [mainState] = useRecoilState(mainStore);
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);
	const wrapperRef = useOutSideClick(() => !selections.length && setOpenBetslip(false), [selections], '.single-coefficient-m');

	useEffect(() => {
		if (verificationResponse?.success || mainState.verificationDisabledManually) setOpenBetslip(true);
	}, [verificationResponse, mainState.verificationDisabledManually]);

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, [window.location.pathname]);

	const { totalOdd } = useMemo(
		() =>
			getBetCalculations([BetCalculationsEnum.TotalOdd], {
				config,
				partnerConfig,
				betType,
				events: selections,
				currencyConfig,
			}),
		[config, betType, currencyConfig, partnerConfig, selections]
	);

	const className = classnames("B-sticky-children", {
		"B-sticky-children-open": openBetslip,
		"B-sticky-children-close": !openBetslip,
	});

	if (windowWidth > 1600 || !config.enableStickyWrapper) return children;

	return (
		<div className="B-sticky-content" ref={wrapperRef}>
			<div className={className}>{children}</div>
			{
				<div className="B-sticky-children">
					<div className="B-head" onClick={() => setOpenBetslip(!openBetslip)}>
						<p className="B-selection">
							{t("Betslip")}
							<span className="B-sticky-count">{getEffectiveSelectionsCount(selections)}</span>
						</p>
						{openBetslip ? (
							<i className="global-icon icon-arrow-down5" />
						) : (
							<p className="B-type">
								{t(BetTypeViewEnum[mainState.betType])}
								<span className="B-sticky-odd">
									{OddConverter(config, totalOdd, oddsFormat)}
								</span>
							</p>
						)}
					</div>
				</div>
			}
		</div>
	);
};

export default StickyWrapper;
